import React from "react";

const AboutPage = () => {
  return (
    <div className="min-h-screen pt-24 font-sans">
      <section className="relative py-20 bg-gradient-to-br from-yellow-100 via-blue-100 to-pink-100 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 text-center relative z-10">
          <span className="inline-block px-6 py-2 bg-gradient-to-r from-blue-500 to-green-500 text-white rounded-full text-sm font-bold uppercase tracking-wide mb-6 shadow-lg">
            Little Winners Dünyasını Keşfet
          </span>
          <h1 className="text-5xl md:text-7xl font-black text-gray-900 mb-6">
            Öğren &{" "}
            <span className="bg-gradient-to-r from-pink-500 to-orange-500 bg-clip-text text-transparent">
              Oyna!
            </span>
          </h1>
          <p className="text-lg md:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
            <span className="font-bold text-blue-600">Little Winners</span>,
            çocukların doyasıya eğlenebileceği, güvenli bir ortamda oyun
            oynayabileceği ve unutulmaz anılar biriktirebileceği bir eğlence
            dünyasıdır! 🏰✨
            <br />
            <br />
            Amacımız; çocuklara enerjilerini en verimli şekilde atabilecekleri
            🏃‍♂️💨, arkadaşlarıyla keyifli vakit geçirebilecekleri 👭 ve
            yüzlerinden gülümsemenin hiç eksik olmayacağı bir alan sunmak! 😊🌟
          </p>
        </div>

        {/* Dalga Efekti (SVG) */}
        <div className="absolute bottom-0 left-0 w-full leading-[0]">
          <svg viewBox="0 0 1440 120" className="w-full h-20 fill-white">
            <path d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,58.7C960,64,1056,64,1152,58.7C1248,53,1344,43,1392,37.3L1440,32L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"></path>
          </svg>
        </div>
      </section>

      <section className="py-16 bg-yellow-400">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: "🎈",
                title: "Sonsuz Enerji",
                desc: "Çocukların güvenle koşturup enerjilerini atabileceği dev parkurlar.",
              },
              {
                icon: "🤝",
                title: "Sosyal Oyun",
                desc: "Yeni arkadaşlar edinerek paylaşmayı ve birlikte oynamayı keşfetme.",
              },
              {
                icon: "🎨",
                title: "Hayal Gücü",
                desc: "Tematik oyun alanlarında yaratıcılığın sınırlarını zorlayan maceralar.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-3xl shadow-xl border-4 border-dashed border-blue-400 flex items-center gap-5 hover:scale-105 transition-transform duration-300"
              >
                <div className="text-5xl">{item.icon}</div>
                <div>
                  <h3 className="font-bold text-xl text-gray-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-snug">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
